import { Rows } from '../../interfaces';
import { getCell, spaceInsteadOfNull, withCellStyles } from '../../utils';
import { CellStyle } from 'xlsx-js-style';
import { leftBold } from 'src/app/util/excelStyles';
import { CompanyWithRoundsDTO } from 'src/app/domain/company/dto/CompanyWithRoundsDTO';
import { EmployeeCrudDTO } from 'src/app/domain/company/dto/EmployeeCRUDDTO';

export const getPreparedData = (data: CompanyWithRoundsDTO[], headers: string[]): Rows => {
  const newData: Rows = [];
  data = data.filter((c) => c.companyMembers?.length);
  newData.push(headers);
  data.forEach((company) => {
    newData.push(...getCompanyRow(company, headers));
    newData.push(...getManyRows(company.companyMembers, headers));
  });
  return newData;
};

export const getManyRows = (members: EmployeeCrudDTO[], headers: string[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = members.map((d) => getNewMapping(d));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(mapped[header]);
    }
    rows.push(row);
  }
  return rows;
};

export const getCompanyRow = (c: CompanyWithRoundsDTO, headers: string[]): Rows => {
  const rows: Rows = [];

  const mappedToHeaders = getNewCompanyMapping(c);

  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      row.push(withCellStyles(mapped[header], leftBold));
    }
    rows.push(row);
  }
  return rows;
};

export const getNewCompanyMapping = (c: CompanyWithRoundsDTO): object[] => {
  const body = {
    'Company/Member': c.name,
    Surname: '',
    Phone: '',
    Email: '',
    Position: '',
  };
  return [body];
};

export const getNewMapping = (member: EmployeeCrudDTO): object => {
  const body = {
    'Company/Member': member.name,
    Surname: spaceInsteadOfNull(member.family),
    Phone: spaceInsteadOfNull(member.phone),
    Email: getCell({
      v: member.mail,
      l: { Target: `mailto:${member.mail}` },
      s: link,
    }),
    Position: spaceInsteadOfNull(member.position),
  };
  return body;
};

const link: CellStyle = {
  font: { color: { rgb: 'FF0000FF' } },
};

